// i18next hands back the key itself when nothing is mapped for it, so a backend error key
// the cms has not been given yet reaches the client as "admin.err.something". Never show one:
// fall back to the generic failure rather than leaking an internal identifier.
export const backendMessage = (t, errKey, fallbackKey = "admin.err.system_error") => {
    const key = errKey || fallbackKey;
    const text = t(key);

    if (text && text !== key) return text;

    const fallback = t(fallbackKey);

    return fallback && fallback !== fallbackKey ? fallback : "Something went wrong. Please try again.";
};

export default backendMessage;
